import _ from 'lodash';
import { DASHLET_MODE } from '../auth/dashlet.const';
import { FEATURE_FLAGS } from './utilities/feature-flag/feature-flag.constants';

export type IConfigType = {
  featureFlags: {
    [key in keyof typeof FEATURE_FLAGS]?: boolean;
  };
} & {
  dashletMode?: DASHLET_MODE;
  currentSugarModule?: string;
  mfeManifest?: any; // structure provided by our /manifest endpoint
  gtmid?: string;
  SLACK_CLIENT_ID?: string;
  APPLICATION_URL?: string;
  TENANT_ID?: string;
  TENANT_IDM_ID?: string;
  CORVANA?: string;
  IDM_TOKEN?: string;
  IS_GRAPHIQL?: boolean;
  SKIP_URL_TENANT?: boolean;
  SUPPRESS_PROP_WARNINGS?: boolean;
  NR_ID?: string;
  GAINSIGHT_PX_ENV_ID?: string;
  STRICT_MODE?: boolean;
};

let config: IConfigType;

export const updateConfig = (cfg: Partial<IConfigType>) => {
  config = Object.freeze(_.assign({}, config, cfg));
};

export const getConfig = () => config;

export const dehydrateFeatureFlags = () => {
  // running this immediately on app init to un-stringify features config
  try {
    const { featureFlags: dehydratedFeatureFlags = '{}' } =
      getConfig() as IConfigType & {
        featureFlags: string;
      };

    // eslint-disable-next-line lodash/prefer-lodash-typecheck
    if (typeof dehydratedFeatureFlags !== 'string') {
      return;
    }

    const featureFlags = JSON.parse(dehydratedFeatureFlags);

    if (typeof featureFlags === 'object') {
      updateConfig({
        featureFlags,
      });
    } else {
      updateConfig({
        featureFlags: {},
      });
    }
  } catch {
    updateConfig({
      featureFlags: {},
    });
  }
};

updateConfig(
  ((window as any) ?? {})?.discoverConfig || (global as any)?.discoverConfig,
);
dehydrateFeatureFlags();
